export default __webpack_public_path__ + "68cc29f88d1219bfe1b4a40b54077ce6.svg";